import { SERVER_API_URL } from './../../app.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';



// type NewType = EntityResponseType;

@Injectable({ providedIn: 'root' })
export class HistoryService {
    private resourceUrl = SERVER_API_URL + 'api/fetch-audit-logs-by-module-wise';


    constructor(private http: HttpClient) {

    }

    getAuditLogByTypeForDataManagement(form_data): Observable<any> {
        return this.http.post<any>(this.resourceUrl, form_data, { observe: 'response' })
    }

}
